/**
 * Parse a backend timestamp (date string or Unix seconds) to epoch milliseconds.
 * Returns 0 for invalid/missing values.
 */
export const parseTimestampMs = (t?: string): number => {
    if (!t) return 0;
    const trimT = String(t).trim();
    // Numeric Unix timestamp (seconds)
    if (/^-?\d+(\.\d+)?$/.test(trimT)) {
        return Math.floor(Number(trimT) * 1000);
    }
    // Date string like "2026-02-14 01:14:42"
    let dateStr = trimT.replace(' ', 'T');
    if (!/(Z|[+-]\d{2}(:?\d{2})?)$/i.test(dateStr)) {
        dateStr += 'Z';
    }
    const d = new Date(dateStr).getTime();
    return Number.isFinite(d) ? d : 0;
};
